import { MenuItem } from "@mui/material";
import "./ActionsOverlay.scss";
import React from "react";
import images from "../../assets/images";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ToasterWithMessage from "../toaster";
import { RESET_CLASS_CODE } from "../../pages/AdminClassroom/api/AdminClassroomQuery";
import { useMutation } from "@apollo/client";
import { FETCH_POLICY_NO_CACHE } from "../../utils/constants";

interface classroomObjectType {
    cCode: string;
    cId: string;
    cName: string;
    cOriginalName: string;
    cStudentsCount: number;
}

interface ActionsProps {
    handleCloseOverlay: () => void;
    actionData: classroomObjectType;
    setRefetchData: any;
    setOpenConfirmationPopup: any;
}

const ActionsOverlay: React.FC<ActionsProps> = ({ handleCloseOverlay, actionData, setRefetchData, setOpenConfirmationPopup }) => {
    const { CopyCode, ResetCode, DeleteClass } = images;
    const { success, error } = ToasterWithMessage();

    const [resetClassCode] = useMutation(RESET_CLASS_CODE, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            success(data?.editClasscode?.message);
            setRefetchData(true);
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    //To copy the class code
    const handleCopyCode = () => {
        success('Copied to clipboard');
        handleCloseOverlay();
    };

    //To copy the class code
    const handleResetCode = () => {
        resetClassCode({
            variables: {
                input: {
                    classroomId: actionData?.cId
                }
            }
        });
        handleCloseOverlay();
    };

    //To delete the classroom
    const handleDeleteClassroom = () => {
        setOpenConfirmationPopup(true);
        handleCloseOverlay();
    }



    return (
        <div className="actionsOverlayContainer">
            <CopyToClipboard text={actionData?.cCode} onCopy={handleCopyCode}>
                <MenuItem className="actionItem">
                    <img src={CopyCode} alt="copycode" />
                    <p className="actionLabel">Copy code</p>
                </MenuItem>
            </CopyToClipboard>
            <MenuItem className="actionItem" onClick={handleResetCode}>
                <img src={ResetCode} alt="resetcode" />
                <p className="actionLabel">Reset code</p>
            </MenuItem>
            <MenuItem className="actionItem" onClick={handleDeleteClassroom}>
                <img src={DeleteClass} alt="deleteclass" />
                <p className="actionLabel">Delete class</p>
            </MenuItem>
        </div>
    )
}

export default ActionsOverlay;
